import {useDataProvider} from "./base-data.provider";
import {useCallback} from "react";

export function useQuizAssessmentQuestionDataProvider() {
  const { request } = useDataProvider();

  const listTags = useCallback(() => {
    return request({
      method: "GET",
      path: "/quiz-assessment-question/tags",
    })
  }, [request]);

  const getQuestionResume = useCallback(() => {
    return request({
      method: "GET",
      path: "/quiz-assessment-question/question-resume",
    })
  }, [request])

  const findQuestion = useCallback((id) => {
    return request({
      method: "GET",
      path: `/quiz-assessment-question/${id}`,
    })
  }, [request])

  const listQuestions = useCallback(({ page, limit, filter }) => {
    return request({
      method: "GET",
      path: `/quiz-assessment-question`,
      query: { page, limit, filter },
    })
  }, [request])

  const listThemes = useCallback(() => {
    return request({
      method: "GET",
      path: `/quiz-assessment-question/themes`,
    })
  }, [request])

  return {
    getQuestionResume,
    listTags,
    findQuestion,
    listQuestions,
    listThemes
  }
}
